import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from "../../Context/ConfigContext";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
import { currentDateAndTime } from "../../Constants/constants";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";
import { decodeData } from "../../Constants/constants";
class NewPolicy extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      isCreatePolicy: "1",
      loadingCreate: false,
      loadingList: false,
      policyBody: "",
      policyTitle: "",
      selectedFileName: "",
      policyFile: null,
      errors: {},
      policyId:"",
      decodedData: [],

    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    this.setState({ loadingList: false, policyId: id || false }, (prevState) => {
        if(this.state.policyId){
            this.getInfo()
        }
    });
  }
   componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
          // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
              const queryParams = new URLSearchParams(window.location.search);
              const encodedData = queryParams.get("abs");
              const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
              if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
              }
            } else {
              console.warn("Permissions not yet available. Retrying...");
            }
        }
    }
  goBack = () => {
    window.history.back();
  };
  handleFileChange = (e) => {
    const errors = {};
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ["application/pdf"];
      const maxFileSize = 20 * 1024 * 1024; // 2MB in bytes
      console.log(file.size);
      if (!allowedTypes.includes(file.type)) {
        errors.policyFile = "Invalid file type. Allowed types: jpg, png, pdf.";
        return errors;
      } else if (file.size >= maxFileSize) {
        errors.policyFile = "File size must be less than 20MB.";
        return errors;
      }
    console.log(file);
    
      this.setState({
        policyFile: file, // File object is stored in state but not rendered directly
        selectedFileName: file.name, // Use file.name to display the file name
        errors: {},
      });
    }
  };

  handleFileUpload = () => {
    const formData = {
        company_policy_id: this.state.policyId || null,
        company_policy_title: this.state.policyTitle,
        company_policy_content_type: "1",
        date: currentDateAndTime(),
        file: this.state.policyFile,
      };

    const { apiHeaderFile, apiURL } = this.context;

    Swal.fire({
        title: "Are you sure?",
        text: `You want to Update policy!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
            this.setState({ loadingCreate:true});
            axios
            .post(
                `${apiURL}Masters/CreateUpdatePolicy`,
                formData,
                {
                headers: { 
                    token: `${localStorage.getItem("token_erp")}`, 
                    "Content-Type": "multipart/form-data", 
                    "x-company-id": localStorage.getItem("company_id_erp"), 
                    "x-user-id": localStorage.getItem("user_id_erp"), 
                },
                }
            )
            .then((response) => {
                const data = response.data;
                if(response.data.success===true){
                Swal.fire({
                    title: `<strong>${
                    response.data.success === true ? 'Success' : 'Failed'
                    }</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                });
        
                this.setState({ loadingCreate:false },()=>{
        
                })
                }
                else{
                Swal.fire({
                    title: `<strong>${
                    response.data.success === true ? 'Success' : 'Failed'
                    }</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                });
                this.setState({ loadingCreate:false });
                }
                
                
            })
            .catch((error) => {
                this.setState({ loadingUpload:false });
                Swal.fire({
                title: `<strong>${
                    'Failed'
                }</strong>`,
                text: "Opps...! Something went wrong!",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
                });
                console.error("Error uploading file:", error);
            });
        }});
  };
  
  handleSubmit = () => {
    const { apiURL, apiHeaderFile,apiHeaderJSON}= this.context;
    const headers = apiHeaderJSON;

    // const errors = this.validateForm();
    // console.log("errors 1", errors);
    // if (Object.keys(errors).length > 0) {
    //     this.setState({errors:errors});
    //     return;
    // }
    
    const formData = {
        company_policy_id: this.state.policyId || null,
        company_policy_title: this.state.policyTitle,
        company_policy_content_type: "2",
        date: currentDateAndTime(),
        company_policy_content: this.state.policyBody,
        ...headers,
    }
    console.log(formData, headers);
    Swal.fire({
        title: "Are you sure?",
        text: `You want to create policy!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
        this.setState({ loadingCreate:true});
    axios
        .post(`${apiURL}Masters/CreateUpdatePolicy`, formData, {
            headers,
        })
        .then((response) => {
            const { success,  } = response.data;
            console.log(response.data);
            if (success === true) {
                Swal.fire({
                    title: `<strong>${
                      response.data.success === true ? "Success" : "Failed"
                    }</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? "success" : "error",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                  });
                this.setState({ loadingCreate:false});
                this.goBack();
            } else {
                Swal.fire({
                    title: `<strong>${
                      response.data.success === true ? "Success" : "Failed"
                    }</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? "success" : "error",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                  });
                this.setState({ loadingCreate:false});
            }
        });
    }});


}
getInfo = () => {

    const { apiHeaderJSON, apiURL } = this.context;
    const headers= apiHeaderJSON;
    this.setState({loadingList:true,});
    axios.get(`${apiURL}Masters/GetPolicyInfo?company_policy_id=${this.state.policyId}`, { headers }).then((response) => {
        const { success,policy_data } = response.data;
        console.log("response.data",response.data);
        console.log("file Name",policy_data[0]?.company_policy_document_url,policy_data[0]?.company_policy_document_url?.split("/"),policy_data[0]?.company_policy_document_url?.split("/")[policy_data[0]?.company_policy_document_url?.split("/")?.length-1]);
        if (success === true) {
            if(policy_data[0]?.company_policy_content_type === "1"){
                this.setState({ 
                    loadingList:false,
                    isCreatePolicy:"1",
                    policyTitle:policy_data[0]?.company_policy_title, 
                    selectedFileName: policy_data[0]?.company_policy_document_url?.split("/")[policy_data[0]?.company_policy_document_url?.split("/")?.length-1],
                    policyBody:"", });
            }
            else{
                this.setState({ 
                    loadingList:false,
                    isCreatePolicy:"2",
                    policyTitle:policy_data[0]?.company_policy_title, 
                    policyBody: policy_data[0]?.company_policy_content,
                    policyFile:null, 
                    selectedFileName:"",});
            }
            

        } else {
            this.setState({loadingList:false,});
        }
    });
}
  removeFile = () => {
    this.setState({
      policyFile: null,
      selectedFileName: "",
      errors: {},
    });
  };
  handleEditorEmailChange = (event, editor) => {
    // const value = event.target.value;

    // Clear the previous timeout if the user is still typing
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new timeout to call the function after 1 second
    this.debounceTimer = setTimeout(() => {
      const policy = editor.getData();
      // Clear the error for the mailBody field
      const errorsList = { ...this.state.errors };
      delete errorsList.policy;

      this.setState({
        policyBody: policy,
        errors: errorsList, // Update errors object
      });
    }, 1000);
  };

  render() {
    const {loadingList} = this.state;
    return loadingList? (
        <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
        <div className="text-center">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
      ):(
      <div className="main-content">
        <div style={{ paddingTop: "3rem" }} className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={this.state.policyId? `Update Policy` : `Create Policy`} primary={`Home`} />
           
              <div className="col-md-12">
                <div style={{ minHeight: "70vh" }} className="card p-4">
                <div className="row">
                <div className="card-header align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">
                    {this.state.policyId? "Update": "Create"} Policy
                    </h4>
                    <button className="btn btn-success btn-sm" 
                      onClick={this.goBack}
                    >
                        <i className="bx ri-arrow-left-circle-line label-icon align-middle fs-4 " />
                    </button>
                </div>
                  <div className="">
                    <div className="">
                      <div className=" d-flex align-items-center justify-content-between gap-3">
                        <div className=" d-flex align-items-center gap-3">
                          <div
                            onClick={() =>
                              this.setState({ isCreatePolicy: "1" })
                            }
                            className={`horizontal-tab ${
                              this.state.isCreatePolicy === "1"
                                ? "active-horizontal-tab"
                                : ""
                            } cursorPointer`}
                          >
                            <i className="ri-file-line" /> File Policy
                          </div>
                          <div
                            onClick={() => {
                              this.setState({ isCreatePolicy: "2" });
                            }}
                            className={`horizontal-tab ${
                              this.state.isCreatePolicy === "2"
                                ? "active-horizontal-tab"
                                : ""
                            } cursorPointer`}
                          >
                            <i className="ri-mail-line" /> {this.state.policyId? "Update":"Text"} Policy
                          </div>
                        </div>
                        {!this.state.loadingCreate ? (
                          <button
                            type="submit"
                            className="btn btn-info btn-label ms-auto waves-effect waves-light"
                            onClick={() => {
                                if(this.state.isCreatePolicy === "1"){
                                    this.handleFileUpload()
                                }
                                else{
                                    this.handleSubmit();
                                }
                              
                            }}
                          >
                            <i className="ri-mail-send-line label-icon align-middle fs-16 me-2" />
                            {this.state.isCreatePolicy === "1"?"Update": this.state.policyId? "Update":"Create" } Policy
                          </button>
                        ) : (
                          <button className="btn btn-info btn-load">
                            <span className="d-flex align-items-center">
                              <span
                                className="spinner-border flex-shrink-0"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </span>
                              <span className="flex-grow-1 ms-2">
                                Loading...
                              </span>
                            </span>
                          </button>
                        )}
                      </div>
                      {this.state.isCreatePolicy === "1" ? (
                        <div className="row">
                          <div className=" d-flex flex-column gap-3">
                            <div className="col-md-6 mb-3 mt-3">
                              <label
                                htmlFor="policyTitle"
                                className="form-label"
                              >
                                Policy Title:
                              </label>
                              <input
                                type="text"
                                id="policyTitle"
                                name="policyTitle"
                                value={this.state.policyTitle}
                                onChange={(e) => { this.setState({ policyTitle: e.target.value }) }}
                                className={`form-control ${
                                  this.state.errors.policyTitle
                                    ? "is-invalid"
                                    : ""
                                }`}
                                placeholder="Enter Template Title"
                              />

                              {this.state.errors.policyTitle && (
                                <div className="invalid-feedback">
                                  {this.state.errors.policyTitle}
                                </div>
                              )}
                            </div>
                            <div
                              style={{ padding: "10px 10px 0 10px" }}
                              className=" d-flex align-items-center gap-3"
                            >
                              <div>
                                <div
                                  style={{ width: "16rem" }}
                                  className="bg-light rounded-3 p-2"
                                >
                                  <small>Selected File:</small>
                                  <div className="d-flex align-items-center ">
                                    <h6
                                      className={`text-truncate mb-0 ${
                                        !this.state.selectedFileName
                                          ? "text-danger"
                                          : ""
                                      }`}
                                      style={{
                                        maxWidth: "15rem", // Adjust max width to fit within the parent div
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {" "}
                                      {this.state.selectedFileName ||
                                        "File not selected"}
                                    </h6>

                                    {this.state.selectedFileName && (
                                      <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={() => this.removeFile()}
                                      ></button>
                                    )}
                                  </div>
                                </div>

                                {/* <h6>{this.state.policyFile?.name}</h6> */}
                              </div>
                              <>
                                <input
                                  type="file"
                                  id={`fileInput`}
                                  style={{ display: "none" }}
                                  onChange={(e) => {
                                    this.handleFileChange(e);
                                  }}
                                  accept=".pdf"
                                />
                                {this.state.selectedFileName ? (
                                  <>
                                    <label
                                      htmlFor={`fileInput`}
                                      className={`btn py-2 mb-0 btn-secondary btn-sm btn-label waves-effect waves-light`}
                                    >
                                      <i className="ri-file-upload-line label-icon align-middle fs-16 me-2" />
                                      Change
                                    </label>
                                  </>
                                ) : (
                                  <>
                                    <label
                                      htmlFor={`fileInput`}
                                      className={`btn btn-${"success"} btn-sm btn-label waves-effect waves-light py-2 mb-0`}
                                    >
                                      <i
                                        className={`ri-file-upload-line label-icon align-middle fs-16 me-2`}
                                      />
                                      {"Choose File"}
                                    </label>
                                  </>
                                )}
                              </>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="row">
                          <div className="card-body">
                            <>
                              <form
                                className=" mt-3"
                              >
                                <div className="row gy-4">
                                  <div className="col-md-6 mb-3 mt-3">
                                    <label
                                      htmlFor="policyTitle"
                                      className="form-label"
                                    >
                                      Policy Title:
                                    </label>
                                    <input
                                      type="text"
                                      id="policyTitle"
                                      name="policyTitle"
                                      value={this.state.policyTitle}
                                      onChange={(e) => { this.setState({ policyTitle: e.target.value }) }}
                                      className={`form-control ${
                                        this.state.errors.policyTitle
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      placeholder="Enter Template Title"
                                    />

                                    {this.state.errors.policyTitle && (
                                      <div className="invalid-feedback">
                                        {this.state.errors.policyTitle}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <CKEditor
                                    editor={ClassicEditor}
                                    data={this.state.policyBody}
                                    name={"policyBody"}
                                    onChange={this.handleEditorEmailChange}
                                  />
                                  {this.state.errors.policyBody && (
                                    <div
                                      style={{
                                        fontSize: "12px",
                                      }}
                                      className=" text-danger"
                                    >
                                      {this.state.errors.policyBody}
                                    </div>
                                  )}
                                </div>
                              </form>
                            </>
                          </div>
                          <div
                            style={{ padding: "10px 10px 0 10px" }}
                            className="modal-footer"
                          >
                            {/* {!this.state.loadingCreate ? (
                              <button
                                type="submit"
                                className="btn btn-info btn-label ms-auto waves-effect waves-light"
                                onClick={() => {
                                  this.handleSendEmail();
                                }}
                              >
                                <i className="ri-mail-send-line label-icon align-middle fs-16 me-2" />
                                Create Policy
                              </button>
                            ) : (
                              <button className="btn btn-info btn-load">
                                <span className="d-flex align-items-center">
                                  <span
                                    className="spinner-border flex-shrink-0"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </span>
                                  <span className="flex-grow-1 ms-2">
                                    Loading...
                                  </span>
                                </span>
                              </button>
                            )} */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NewPolicy;   
